module.exports = __webpack_public_path__ + "static/media/Hydraulics_Major_Filter_Xparent.a1ba4840.png";